
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Question from "./Question";

function TabArea(props) {

    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {
                            props.questions.map((item, index) => {
                                return <Question {...item} key={item.questionId} />
                            })
                        }
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

export default TabArea
